export enum ChangelogType {
  'NEW',
  'UPDATE',
  'NONE',
}
